module.exports = __webpack_public_path__ + "static/media/Enemy_05.71474868.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/RoleComponent/Enemy_05.png
// module id = 1638
// module chunks = 0